import { RHFSelect } from '@talentmesh/ui/components/rhf-select';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';
import directReportsOptions from './DirectReportsOptions';
import UIStrings from '@/Utils/UIStrings';

function DirectReports() {
    const options = directReportsOptions.map((o) => ({ id: String(o.id), name: o.name }));

    return (
        <RHFSelect
            label={`${UIStrings.DirectReports}*`}
            name={JobDetailsFieldTypes.DirectReports}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.DirectReports}
        />
    );
}

export default DirectReports;
